import React, { useEffect, useState } from 'react';
import classes from './ProjectsManagement.module.css';
import SideBarSkeleton from '../../../Component/SideBarSkeleton';
import { Col, Container, Row } from 'react-bootstrap';
import CustomMaterialTable from '../../../Component/CustomMaterialTable';
import { AiFillEye } from 'react-icons/ai';
import { FiEdit } from 'react-icons/fi';
import { MdOutlineUpload } from 'react-icons/md';
import Button from '../../../Component/Button/Button';
import SearchInput from '../../../Component/SearchInput';
import { useNavigate } from 'react-router-dom';
import { FaToggleOn } from 'react-icons/fa';
import DropDown from '../../../Component/DropDown/DropDown';
import { dateFilterOptions } from '../../../constant/commonData';
import {
  useActiveDeactiveProjectMutation,
  useAddOrEditUnitMutation,
  useDeleteProjectMutation,
  useGetCompanyProjectsQuery,
  useRefreshProjectMutation,
  useUpgradeToPremiumOrFeaturedMutation
} from '../../../store/apiSlice/apiSlice';
import { toast } from 'react-toastify';
import useDebounce from '../../../CustomHooks/useDebounce';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import { useSelector } from 'react-redux';
import { HiRefresh } from 'react-icons/hi';
import { recordsLimit } from '../../../config/apiUrl';
import UnitAddModal from '../../../Component/UnitAddModal';
import AreYouSureModal from '../../../modals/AreYouSureModal';
import UpgradingListingModal from '../../../modals/UpgradingListingModal/UpgradingListingModal';
import { isMobileViewHook } from '../../../CustomHooks/isMobileViewHook';

/*eslint-disable*/

const tableData = Array(10)
  .fill({
    id: '5645',
    date: '2020.11.12',
    category: 'For Sale',
    type: 'broker',
    title: 'Text text',
    location: 'London',
    status: 'Active',
    agent: 'John Smith'
  })
  ?.map((item) => ({ ...item, id: Math.floor(Math.random() * 10000) }));

function ProjectsManagement() {
  const { selectedLanguage } = useSelector((state) => state?.languageReducer);
  const { t } = useTranslation(['dashboardProjects', 'locationComp']);
  const navigate = useNavigate();
  const [searchText, setSearchText] = useState('');
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);
  const [dateFilter, setDateFilter] = useState(dateFilterOptions[0]);

  const [isFeaturedModalOpen, setIsFeaturedModalOpen] = useState(null);
  const [isUnitAddModal, setIsUnitAddModal] = useState(null);
  const [page, setPage] = useState(1);
  const [is768, setIs768] = useState(false);

  const [refreshApi, { isLoading: isRefreshing }] = useRefreshProjectMutation();
  const [upgradeApi, { isLoading: isUpgradeLoading }] = useUpgradeToPremiumOrFeaturedMutation();
  const [addUnitApi, { isLoading: isAddUnitLoading }] = useAddOrEditUnitMutation();

  // active deactive api
  const [activeDeactiveApi, { isLoading: isActiveDeactive }] = useActiveDeactiveProjectMutation();

  // Delete

  const [deleteRecordsApi, { isLoading: isDeleting }] = useDeleteProjectMutation();
  //  get company projects
  const debounceSearch = useDebounce(searchText, 500);
  const { data: projectsGetApi, isLoading } = useGetCompanyProjectsQuery({
    page: page,
    search: debounceSearch,
    sortBy: dateFilter?.value
  });

  // handle active deactive

  const handleActiveDeactive = async (slug, data) => {
    const response = await activeDeactiveApi({ slug, data });
    if (response?.data) {
      toast.success(t('toast.successMessage'));
      setSelectedItem(null);
    }
  };

  // Refresh Api
  const handleRefresh = async (slug, url) => {
    const response = await refreshApi({ slug, url });
    if (response?.data) {
      toast.success(t('toast.refreshProject'));
      setSelectedItem(null);
    }
  };

  //  delete api
  const deleteMultiple = async () => {
    const res = await deleteRecordsApi({ ids: selectedRows?.map((item) => item._id) });
    if (res?.data) {
      toast.success(
        `${selectedRows?.length > 1 ? t('events') : t('event')} ${t(toast.deletedMessage)}.`
      );
      setSelectedRows([]);
    }
  };

  const headings = [
    { id: 'listingId', label: t('table.col1') },
    {
      id: 'date',
      label: t('table.col2'),
      renderValue: (item, col) => {
        return moment(item[col?.id]).format('YYYY.DD.MM ');
      }
    },
    {
      id: 'type',
      label: t('table.col3'),
      renderValue: (item) => {
        return item?.projectType?.title[selectedLanguage];
      }
    },
    {
      id: 'title',
      label: t('table.col4'),
      renderValue: (item) => {
        return item?.name[selectedLanguage];
      }
    },
    {
      id: 'address',
      label: t('table.location')
    },
    {
      id: 'isActive',
      label: t('table.col5'),
      // renderValue: (item) => {
      //   return item?.isActive ? `${t('table.active')}` : `${t('table.deActive')}`;
      // }
      renderValue: (item, col) => (
        <span>
          {item?.isActive ? `${t('table.active')}` : `${t('table.deActive')}`}{' '}
          {item?.isPremium ? '/Premium' : item?.isFeatured ? '/Featured' : ''}
        </span>
      )
    },

    { id: 'options', label: t('table.col8'), align: 'center' }
  ];

  // const headings = [
  //   { id: 'id', label: 'ID' },
  //   { id: 'date', label: 'CREATION DATE' },
  //   { id: 'type', label: 'TYPE' },
  //   { id: 'title', label: 'TITLE' },
  //   { id: 'location', label: 'LOCATION' },
  //   { id: 'status', label: 'STATUS' },
  //   // { id: 'agent', label: 'AGENT' },
  //   { id: 'options', label: 'OPTIONS', align: 'center' }
  // ];

  useEffect(() => {
    isMobileViewHook(setIs768, 768);
  }, []);

  return (
    <SideBarSkeleton>
      <Container fluid className={classes.page}>
        <Row>
          <Col md={12} className={classes.mb58}>
            <div className={classes.header}>
              <div className={classes.left}>
                <SearchInput
                  placeholder={t('table.searchInput')}
                  setter={setSearchText}
                  state={searchText}
                  variant="dashboard"
                  containerStyle={{
                    width: '300px',
                    border: '1px solid #E5E5E5',
                    marginBottom: '10px',
                    overflowY: 'hidden'
                  }}
                />
                <DropDown
                  label={!is768 ? t('table.sortByDate') : ''}
                  containerClassName={classes.dropDownContainer}
                  customStyle={{
                    padding: '0px 6px',
                    minHeight: '40px',
                    minWidth: is768 ? '300px' : '200px'
                  }}
                  options={dateFilterOptions}
                  setValue={(e) => {
                    setDateFilter(e);
                  }}
                  value={dateFilter}
                  getOptionLabel={(e) => {
                    return e?.[selectedLanguage];
                  }}
                  // isClearable={true}
                />
              </div>
              <div className={classes.headerRight}>
                <Button
                  borderRadius={'8px'}
                  className={classes.headerBtn}
                  onClick={() => navigate('/agent/projects-management/new-project')}>
                  {t('table.createNewProject')}
                </Button>
                <Button
                  borderRadius={'8px'}
                  className={classes.deleteBtn}
                  disabled={selectedRows?.length == 0}
                  onClick={deleteMultiple}>
                  {isDeleting ? t('table.deleting') : t('table.delete')}
                </Button>
              </div>
            </div>
          </Col>
          <Col md={12} className="pb-3">
            <h5 className={classes.heading}>{t('table.title')}</h5>
          </Col>
          <Col md={12}>
            <CustomMaterialTable
              noDataText={t('table.noDataText')}
              headings={headings}
              data={projectsGetApi?.data}
              showOptionsColumn
              isLoading={isLoading}
              setPage={setPage}
              page={page}
              totalRecords={Math.ceil(projectsGetApi?.totalRecords / recordsLimit)}
              options={[
                {
                  label: t('table.options.view'),
                  icon: <AiFillEye size={18} />,
                  onClick: (label, item) => {
                    navigate(`/projects/${item?.slug}`);
                  }
                },
                {
                  label: t('table.options.refresh'),
                  icon: <HiRefresh size={18} />,
                  onClick: (label, item) => {
                    setSelectedItem({ ...item, flag: 'refresh' });
                  }
                },
                {
                  label: t('table.options.edit'),
                  icon: <FiEdit size={18} />,
                  onClick: (e, rowData) => {
                    navigate(`/agent/projects-management/edit-project/${rowData.slug}`);
                  }
                },
                {
                  label: (e) =>
                    !e?.isActive ? t('table.options.activate') : t('table.options.deactivate'),
                  icon: <FaToggleOn size={18} />,
                  onClick: (label, item) => {
                    setSelectedItem({ ...item, flag: 'active-deactive' });
                  },
                  switch: true
                },
                {
                  label: t('table.options.upgradeToPremiumORFeatured'),
                  onClick: (label, item) => {
                    setIsFeaturedModalOpen({ ...item, boolean: true });
                  },

                  icon: <MdOutlineUpload size={18} />
                },
                {
                  label: t('table.options.addUnitLabel'),
                  onClick: (label, item) => {
                    setIsUnitAddModal({ ...item, boolean: true });
                    // setIsFeaturedModalOpen({ ...item, boolean: true });
                  },

                  icon: <MdOutlineUpload size={18} />
                },
                {
                  label: 'View Units',
                  onClick: (label, item) => {
                    navigate(`/agent/projects-units/${item?.slug} `);
                  },

                  icon: <MdOutlineUpload size={18} />
                }
              ]}
              onOptionClick={() => {}}
              selectedRows={selectedRows}
              setSelectedRows={setSelectedRows}
              allowMultipleSelection
            />
          </Col>
        </Row>
      </Container>

      {isUnitAddModal && (
        <UnitAddModal
          onClick={async (e) => {
            const response = await addUnitApi({
              slug: isUnitAddModal?.slug,
              data: e,
              url: `project/addProjectUnit/${isUnitAddModal?.slug}`
            });
            if (response?.data) {
              toast.success(t('toast.unitAdded'));
              setIsUnitAddModal(false);
            }
          }}
          show={isUnitAddModal?.boolean}
          setShow={setIsUnitAddModal}
          isApiCall={isAddUnitLoading}
        />
      )}
      {selectedItem?.flag == 'active-deactive' && (
        <AreYouSureModal
          label1Icon={false}
          label2Icon={false}
          title={t('activeDeactiveModal.title')}
          label1={t('activeDeactiveModal.yesBtn')}
          label2={t('activeDeactiveModal.noBtn')}
          show={selectedItem?.flag == 'active-deactive'}
          setShow={setSelectedItem}
          subTitle={`${
            selectedItem?.isActive
              ? t('activeDeactiveModal.deactiveText')
              : t('activeDeactiveModal.activeText')
          } `}
          isApiCall={isActiveDeactive}
          onClick={() =>
            handleActiveDeactive(selectedItem?.slug, selectedItem?.isActive ? false : true)
          }
        />
      )}

      {selectedItem?.flag == 'refresh' && (
        <AreYouSureModal
          label1Icon={false}
          label2Icon={false}
          label1={t('activeDeactiveModal.yesBtn')}
          label2={t('activeDeactiveModal.noBtn')}
          show={selectedItem?.flag == 'refresh'}
          setShow={setSelectedItem}
          subTitle={t('refreshModal.text')}
          title={t('refreshModal.title')}
          isApiCall={isRefreshing}
          onClick={() => {
            handleRefresh(selectedItem?.slug);
          }}
        />
      )}

      {isFeaturedModalOpen?.boolean && (
        <UpgradingListingModal
          show={isFeaturedModalOpen?.boolean}
          setShow={setIsFeaturedModalOpen}
          isSubmitting={isUpgradeLoading}
          onSubmit={async (params) => {
            const res = await upgradeApi({
              slug: isFeaturedModalOpen?.slug,
              data: params,
              type: 'project'
            });
            if (res?.data) {
              setIsFeaturedModalOpen(false);
              return toast.success(t('toast.projectUpgraded'));
            }
          }}
        />
      )}
    </SideBarSkeleton>
  );
}

export default ProjectsManagement;
